import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setTempEmail, sendOtp } from '../store/authSlice';
import logo from '../assets/logo.jpeg';




const Login = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated && user) {
      if (user.role === 'bde') {
        navigate('/bde/dashboard', { replace: true });
      } else if (user.role === 'super_admin') {
        // If admin lands here logged in, redirect them too
        navigate('/admin/dashboard', { replace: true });
      }
    }
  }, [isAuthenticated, user, navigate]);

  const onBDEFinish = async (values) => {
    setLoading(true);
    try {
      const email = values.email;

      // Dispatch sendOtp
      dispatch(setTempEmail(email));
      await dispatch(sendOtp(email)).unwrap();

      message.success('OTP sent to your email');
      navigate('/otp');

    } catch (err) {
      message.error('Failed to send OTP: ' + err);
    }
    setLoading(false);
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      position: 'relative',
      padding: '24px 0',
      overflowX: 'hidden'
    }}>
      {/* Decorative blobs */}
      <div style={{ position: 'absolute', top: -100, left: -100, width: 400, height: 400, background: '#2563eb', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>
      <div style={{ position: 'absolute', bottom: -100, right: -100, width: 400, height: 400, background: '#8b5cf6', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>

      <Card
        style={{ width: 400, border: '1px solid rgba(255,255,255,0.1)' }}
        styles={{ body: { padding: '32px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img
            src={logo}
            alt="Logo"
            style={{ height: 56, width: 'auto', objectFit: 'contain', marginBottom: 12 }}
          />
          <h1 style={{ color: '#fff', margin: 0, fontSize: 24 }}>
            BDE LOGIN
          </h1>
          <p style={{ color: '#94a3b8', marginTop: 8 }}>Sign in to continue</p>
        </div>

        <Form
          name="bde_login"
          onFinish={onBDEFinish}
          layout="vertical"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input placeholder="bde@example.com" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Get OTP
            </Button>
          </Form.Item>
          <Button type="link" block onClick={() => navigate('/register')}>
            Register as New BDE
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
